<template>
  <v-container grid-list-lg fluid>
    <v-toolbar dense flat color="grey lighten-3">
      <v-toolbar-title>New Department</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="submit()">Save</v-btn>
      <v-btn color="primary" text @click="close()">Cancel</v-btn>
    </v-toolbar>
    <!-- <ModelTitle title="New Department" @close="close()" /> -->

    <v-card-text>
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field outlined :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
            v-model="Class.name" label="Name"></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6" offset-md="6">
          <v-text-field outlined dense hide-details @focus="$event.target.select()" class="right-input"
            v-model="Class.defaultFee" label="Amount"></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <div class="mb-1">
            <div>Contact Information</div>
            <div>This information will be sent to anyone who fills out the application via email.</div>
          </div>
          <quill-editor :content="Class.contactInformation" :options="editorOption" @change="onContactInformationChange($event)" />
        </v-col>
        <v-col cols="12" sm="12">
          <div class="mb-1">
            <div>Contact Information For Pending Balance Letter</div>
            <div>This information will be sent to anyone whose balance is pending for this department.</div>
          </div>
          <quill-editor :content="Class.letterContactInformation" :options="editorOption" @change="onLetterContactInformationChange($event)" />
        </v-col>
        <v-col cols="12" sm="12">
          <quill-editor :content="Class.description" :options="editorOption" @change="onEditorChange($event)" />
          <!-- <v-textarea outlined dense hide-details auto-grow v-model="Class.description"
            :label="$t('labels.description')"></v-textarea> -->
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            label="Collect Fees in Advance"
            hide-details
            outlined
            dense
            v-model="Class.metadata.preCollectFee"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            label="Count In Subscription"
            hide-details
            outlined
            dense
            v-model="Class.countInSubscription"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            label="Kids Class Program"
            hide-details
            outlined
            dense
            v-model="Class.isChild"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" text @click="close()">Close</v-btn>
      <v-btn color="primary" :loading="loading" dark @click="submit()">Save</v-btn>
    </v-card-actions> -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import classService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  name: "create-Class",
  props: {
    createDialog: {
      default: false,
    },
    createFromStore: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      editorOption: {
        placeholder: 'Description',
      },
      Class: {
        name: null,
        defaulFee: null,
        note: null,
        metadata: {
          preCollectFee: false
        }
      },
    };
  },
  components: {quillEditor},
  mixins: [validationMixin],
  validations: {
    Class: {
      name: {
        required,
      },
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Class.name.$dirty) return errors;
      if (!this.$v.Class.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  methods: {
    onEditorChange(value) {
      this.Class.description = value.html
    },
    onContactInformationChange(value) {
      this.Class.contactInformation = value.html
    },
    onLetterContactInformationChange(value) {
      this.Class.letterContactInformation = value.html
    },
    close() {
      this.empty();
      this.$router.go(-1)
    },
    empty() {
      this.Class = {
        name: null,
        defaulFee: null,
        note: null,
        metadata: {
          preCollectFee: false
        }
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return classService
          .create(this.Class)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Class is created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped>
/* .ql-editor>.ql-blank {
  min-height: 300px;
} */
</style>
